
import bridge from '@/utils/bridge';
import { invenstemInManagerInfo } from '../../api/tax';

// const getUserInfo = async () => new Promise(resolve => setTimeout(() => resolve({
//   bean: {
//     queryData: null,
//     created: 1511255041000,
//     updated: 1511331210000,
//     relationId: 5,
//     managerUserId: 177,
//     invenstemUserId: 200,
//     ttdUserId: 207,
//     invitationCode: '585197', // 邀请码
//     relationData: 1511331149000, // 关联时间
//     specificCode: 'SPECIFIC_ORG_ORDINARY', // 在该管理机构下的 投资者类型
//     riskLevel: null, // 风险等级
//     invenstemName: '姓名', // 投资者名称 机构名称或个人名称
//     representativeUserName: null, // //投资者名称  经办人名称
//     idCardNo: '522102198905081210', // 投资者名称  经办人名称 身份证号码
//     invenstemMobile: null, // 手机号
//     applyConversion: 0, // 是否申请 投资者类型转换 0：未申请 1：已申请
//     conversionState: null, // 判断类型转换状态  0：待审核  1：审核失败  2：审核通过
//     auditRemark: null, // 信息变更审核备注
//     typeAuditRemark: null, // 类型转换审核备注
//     position: '', // 投资者职务，机构为经办人职务
//     changeSpecificCode: null, // 变更后的用户类型状态
//     changeState: null, // 资料变更状态 0：待审核  1：审核失败  2：审核通过
//     evaluationId: null, // 风险测评ID。Long型
//     needInvestorCertification: true, // 是否需要做特定对象认证 false：不需要 true：需要
//     needRisk: true, // 是否需要做风险测评false：不需要 true：需要
//     managerNeedSignTxtDocs: false, // 管理人是否配置需要签署 税收文件
//     signTxtDocsInfo: 0, // 投资者税收文件签署状态。0：未签署 1：待投资者签署  2：待管理人签署  10:签署完成
//     needSubscriptionFee: false, // 是否需要填写认申购费
//   },
// }), 1000));


const user = {
  state: {
    userInfo: {},
    userInfoPromise: null,
    investorUserInfo: {},
  },

  mutations: {
    userInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    userInfoPromise(state, userInfoPromise) {
      state.userInfoPromise = userInfoPromise;
    },
    investorUserInfo(state, investorUserInfo) {
      state.investorUserInfo = investorUserInfo;
    },
  },

  actions: {
    async getUserInfo({ commit, dispatch }) {
      const promise = new Promise((resolve, reject) => {
        setTimeout(() => {
          bridge.callHandler('getInvestorUserInfo', { msg: '获取用户信息' }, async (data) => {
            const obj = JSON.parse(data);
            dispatch('changeAu', obj.au);
            commit('investorUserInfo', obj);
            const params = {
              userId: obj.platformUserId,
              invenstemUserId: obj.invenstemUserId,
            };
            const response = await invenstemInManagerInfo(params, obj.au);
            if (response.code === 0) {
              resolve(response.data);
            } else {
              reject(response);
            }
          });
        }, 300);
      });
      commit('userInfoPromise', promise);

      const { bean } = await promise;
      commit('userInfo', bean);
      return bean;
    },
  },
};

export default user;
